/// <amd-module name="Dashboards/DashboardView/src/redux/Module" />
import { AnyAction, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

import { DashboardViewAwareState } from "../model/DashboardViewState";
import { dashboardViewStateReducer } from "./reducers/Reducer";
import { DashboardRefreshSagas } from "./sagas/RefreshSaga";
import { DashboardViewSagas } from "./sagas/Saga";
import { ThrottlingSagas } from "./sagas/ThrottlingSaga";

export const dashboardViewModule: ISagaModule<DashboardViewAwareState> = (function() {
    const reducerMap: ReducersMapObject<DashboardViewAwareState, AnyAction> = {
        dashboardViewState: dashboardViewStateReducer as any
    };

    return {
        id: "dashboard-view",
        reducerMap,
        sagas: [DashboardViewSagas.rootSaga, DashboardRefreshSagas.refreshSaga, ThrottlingSagas.rootSaga]
    };
})();
